import { ThemedText } from '@/components/themed-text';
import { getMissingPublicEnvDetails, getPublicEnvConfigError } from '@/lib/app-public-env';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

export function AppConfigErrorBanner() {
  const message = getPublicEnvConfigError();
  const missing = getMissingPublicEnvDetails();
  if (!message || missing.length === 0) return null;

  // Nome de variável e comando de build são para quem gera o app; quem usa
  // só precisa saber o que fazer.
  if (!__DEV__) {
    return (
      <View className="border-destructive/40 bg-destructive/10 mx-4 mb-4 rounded-xl border px-4 py-4">
        <ThemedText className="text-sm text-foreground">
          Esta versão do app está com um problema. Atualize para a versão mais recente.
        </ThemedText>
      </View>
    );
  }

  return (
    <View className="border-destructive/40 bg-destructive/10 mx-4 mb-4 rounded-xl border px-4 py-4">
      <View className="mb-2 flex-row items-center gap-2">
        <Ionicons name="warning-outline" size={22} className="text-destructive" />
        <ThemedText className="text-destructive font-semibold text-base">
          Configuração incompleta neste instalável
        </ThemedText>
      </View>
      <ThemedText className="mb-2 text-sm text-foreground">
        Faltando no bundle deste build:
      </ThemedText>
      {missing.map(({ key, label }) => (
        <View key={key} className="mb-1 pl-1">
          <ThemedText className="text-destructive font-mono text-xs">{key}</ThemedText>
          <ThemedText className="text-muted-foreground text-xs">{label}</ThemedText>
        </View>
      ))}
      <ThemedText className="mt-2 text-sm leading-relaxed text-foreground">
        Se já configurou no EAS (ambiente production), rode um novo{' '}
        <ThemedText className="font-semibold">eas build --profile production-store</ThemedText> e
        reinstale no TestFlight — o IPA atual pode ser de antes do env:push.
      </ThemedText>
    </View>
  );
}
